import _ from 'lodash';
import { FETCH_NOTIFICATIONS_SUCCESS } from '../../actions/fetch-notifications';
import { NEW_NOTIFICATION } from '../../actions/user-socket';

export default (state = [], action = {}) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_SUCCESS:
      return _.union(state, action.payload.map(notification => notification._id));
    case NEW_NOTIFICATION:
      return [...state, action.payload._id];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/notifications/idList.js